import React from 'react';

function Td ({ title, value, children, styleTd, colSpan }) {
  return (
    <td
      colSpan={colSpan ? colSpan : '1'}
      style={{
        border: '#eee solid 1px',
        fontSize: '12px',
        verticalAlign: 'center',
        padding: '4px 12px',
        ...styleTd
      }}
    >
      {children ? children : <TdItem title={title} value={value} />}
    </td>
  );
}

function TdItem ({ title, value }) {
  return (
    <div>
      <strong>{title}{': '}</strong>
      <span style={{ marginLeft: '5px' }}>{value}</span>
    </div>
  );
}
export default Td;



// WEBPACK FOOTER //
// ./src/pages/controleTarefas/Citologia/Impressao/Table/Td/index.js